import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRangePicker = ({ dateRange, handleDateRangeChange, activeTab = 'catalog' }) => {
  const [calendarRange, setCalendarRange] = useState([
    dateRange?.startDate ? new Date(dateRange.startDate) : null,
    dateRange?.endDate ? new Date(dateRange.endDate) : null,
  ]);

  const [startDate, endDate] = calendarRange;

  // Keep picker synced if parent updates externally
  useEffect(() => {
    setCalendarRange([
      dateRange?.startDate ? new Date(dateRange.startDate) : null,
      dateRange?.endDate ? new Date(dateRange.endDate) : null,
    ]);
  }, [dateRange?.startDate, dateRange?.endDate]);

  // Set date restrictions based on active tab
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day
  
  const maxDate = activeTab === 'catalog' ? today : null; // Catalog: only past dates (up to today)
  const minDate = activeTab === 'task' ? today : null; // Tasking: only future dates (from today onwards)
    const ReadOnlyInput = React.forwardRef(({ value, onClick }, ref) => (
      <input
        value={value}
        onClick={onClick}
        ref={ref}
        readOnly
        className="dark-datepicker-input"
      />
    ));
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#5A5A5A",
        padding: "6px 10px",
        borderRadius: "6px",
        gap: "8px",
      }}
    >
      <span style={{ fontSize: "14px", color: "#FFFFFF", fontWeight: "bold" }}>
        Date Range
      </span>

      <DatePicker
        selectsRange
        startDate={startDate}
        endDate={endDate}
        minDate={minDate} // Tasking: only future dates (from today onwards)
        maxDate={maxDate} // Catalog: only past dates (up to today)
        shouldCloseOnSelect={true}
        onChange={(update) => {
          let [start, end] = update || [];

          // Swap if user clicks backwards
          if (start && end && start > end) [start, end] = [end, start];

          // Update local picker UI immediately
          setCalendarRange([start || null, end || null]);

          // Reset end when only start picked
          if (start && !end) return;

          // ✅ When both selected → emit to ExplorePage
          if (start && end) {
            // Format dates in local timezone to avoid day-before bug
            const formatLocalDate = (date) => {
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              return `${year}-${month}-${day}`;
            };
            
            handleDateRangeChange({
              startDate: formatLocalDate(start),
              endDate: formatLocalDate(end),
            });

            // Auto-close smoothly
            setTimeout(() => document.activeElement?.blur(), 50);
          }
        }}
        placeholderText="Select date range"
        dateFormat="dd/MM/yyyy"
        className="dark-datepicker-input"
        calendarClassName="dark-calendar"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        customInput={<ReadOnlyInput />}
      />
    </div>
  );
};

export default DateRangePicker;
